export default {
  title: '刪除會員媒體',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": null,
        }
      }
    },
  ]
}

